import Vue from 'vue'
import store from '@/store'
import sw from '@/utils/sweetAlert'
import auth from '@/utils/authentication'

/**
 * メールを送信する
 * @param {Object} mailContent メール本文
 * @param {String} sendType 業務開始連絡か日報投稿かなどを判別するタイプ
 */
function sendMail (mailContent, sendType) {
  // メールを送信するGraphAPI
  const url = 'https://graph.microsoft.com/v1.0/me/sendMail'
  // new XMLHttpRequest オブジェクトを作成
  const request = new XMLHttpRequest()
  // URL https://graph.microsoft.com/v1.0/me/sendMail に対する POST-リクエスト
  request.open('POST', url, true)
  // レスポンスを受け取った後に呼び出される
  request.onreadystatechange = () => {
    // 401(認証)エラーかつ再認証がまだなら再認証を行う
    if (request.readyState === XMLHttpRequest.DONE) {
      if (request.status >= 400 && sessionStorage.getItem('isReAuth') !== 'true') {
        sessionStorage.setItem('sendType', sendType)
        localStorage.setItem('mailContent', mailContent)
        auth.reAuthenticate()
        return
      // 401(認証)エラーかつ再認証を試みた後ならエラーを表示
      } else if ((request.status >= 400 && sessionStorage.getItem('isReAuth') === 'true') || request.status === 0) {
        Vue.swal({
          icon: 'error',
          html: '送信に失敗しました<br>ネットワーク環境に異常が無いか確認してください'
        })
      // 401(認証)エラーが出ていないなら成功(諸説あり)
      } else {
        const message = {
          sendTeams: '保存 & 送信しました',
          sendWork: '送信しました',
          sendTest: 'テスト送信しました',
          reSend: '再送しました'
        }
        sw.toastAlert('success', message[sendType])
        if (sendType !== 'sendWork') {
          // 送信した後、リロードする
          store.dispatch('getDiaries')
        }
      }
      sessionStorage.removeItem('sendType')
      sessionStorage.removeItem('isReAuth')
      localStorage.removeItem('mailContent')
    }
  }
  // ヘッダー情報を追加する(ここでコンテンツタイプや、アクセストークンを追加)
  request.setRequestHeader('Content-Type', 'application/json')
  request.setRequestHeader('Authorization', 'Bearer ' + sessionStorage.getItem('accessToken'))
  // 設定したURLにリクエスト送信
  request.send(mailContent)
}

export default {sendMail}



// WEBPACK FOOTER //
// ./src/utils/msGraphApi.js